module.exports = __webpack_public_path__ + "static/media/bootstrap.da53dc34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/frontend/bootstrap.png
// module id = 1528
// module chunks = 0